import { formatify } from "./formatify.js";

export function formatifyHtml(node: HTMLElement): string {
	for (const child of node.childNodes) {
		if (child.nodeType === 3) {
			if (child.nodeValue) {
				const div = document.createElement("div");
				div.classList.add("contents");
				div.innerHTML = formatify(child.nodeValue);
				child.replaceWith(div);
			}
		} else if (child.nodeType === 1) {
			const node = child as HTMLElement;
			node.innerHTML = formatifyHtml(node);
		}
	}
	return node.innerHTML;
}
